/**
 * Base Map Styles
 *
 * Map style URLs and blank canvas style factory.
 */

import type { StyleSpecification } from "maplibre-gl";
import { wondermapsDefault } from "../themes";

// Base map style URLs (free tile providers - for construction/debug mode)
export const MAP_STYLES = {
  // Clean, minimal style suitable for overlays
  light: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
  // Dark mode alternative
  dark: "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json",
  // Satellite imagery (requires Mapbox token for production)
  satellite: "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json",
} as const;

/**
 * Blank canvas style - no OSM tiles, just solid background.
 * Used for Visitor maps and Admin when construction mode is off.
 * The boundary layer fill becomes the map "canvas".
 */
export function createBlankMapStyle(
  backgroundColor?: string,
  spriteUrl?: string
): StyleSpecification {
  const bgColor = backgroundColor || wondermapsDefault.colors.background;
  return {
    version: 8,
    name: "Wondermaps Blank Canvas",
    ...(spriteUrl && { sprite: spriteUrl }),
    sources: {},
    layers: [
      {
        id: "background",
        type: "background",
        paint: {
          "background-color": bgColor,
        },
      },
    ],
  };
}
